import { render } from "./structure.vue?vue&type=template&id=19d0cac2&scoped=true"
import script from "./structure.vue?vue&type=script&lang=js"
export * from "./structure.vue?vue&type=script&lang=js"

import "./structure.vue?vue&type=style&index=0&id=19d0cac2&scoped=true&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d0cac2"]])

export default __exports__